export const ActionTypes = {
  SESSION_LIST_LOADED: "SESSION_LIST_LOADED",
  SESSION_LIST_LOAD_FAILED: "SESSION_LIST_LOAD_FAILED",
  SESSION_SELECTED: "SESSION_SELECTED",
  SESSION_MESSAGES_LOADED: "SESSION_MESSAGES_LOADED",
  SESSION_MESSAGES_LOAD_FAILED: "SESSION_MESSAGES_LOAD_FAILED",
  SESSION_CREATING: "SESSION_CREATING",
  SESSION_CREATED: "SESSION_CREATED",
  SESSION_CREATE_FAILED: "SESSION_CREATE_FAILED",
  SESSION_DELETED: "SESSION_DELETED",
  SESSION_TITLE_SET: "SESSION_TITLE_SET",
  MESSAGE_SENT: "MESSAGE_SENT",
  SSE_SUMMARY_RECEIVED: "SSE_SUMMARY_RECEIVED",
  SSE_ERROR_RECEIVED: "SSE_ERROR_RECEIVED",
  SSE_STATUS_RECEIVED: "SSE_STATUS_RECEIVED",
  STREAM_COMPLETED: "STREAM_COMPLETED"
};

export const initialState = {
  sessionList: [],
  activeSessionId: null,
  isLoadingList: true,
  isCreating: false,
  openedSessions: {}
};

function updateSession(state, id, updates) {
  return {
    ...state,
    openedSessions: {
      ...state.openedSessions,
      [id]: { ...state.openedSessions[id], ...updates }
    }
  };
}

function appendMessage(state, id, msg) {
  const session = state.openedSessions[id];
  return {
    ...state,
    openedSessions: {
      ...state.openedSessions,
      [id]: {
        ...session,
        messages: [...(session?.messages || []), msg]
      }
    }
  };
}

export default function agentChatReducer(state, action) {
  switch (action.type) {
    case ActionTypes.SESSION_LIST_LOADED:
      return { ...state, sessionList: action.sessions, isLoadingList: false };

    case ActionTypes.SESSION_LIST_LOAD_FAILED:
      return { ...state, isLoadingList: false };

    case ActionTypes.SESSION_SELECTED: {
      const next = { ...state, activeSessionId: action.sessionId };
      if (!state.openedSessions[action.sessionId]) {
        next.openedSessions = {
          ...state.openedSessions,
          [action.sessionId]: { status: "loading", messages: [] }
        };
      }
      return next;
    }

    case ActionTypes.SESSION_MESSAGES_LOADED: {
      if (state.openedSessions[action.sessionId]?.status !== "loading") {
        return state;
      }
      return updateSession(state, action.sessionId, {
        status: "idle",
        messages: action.messages
      });
    }

    case ActionTypes.SESSION_MESSAGES_LOAD_FAILED: {
      if (state.openedSessions[action.sessionId]?.status !== "loading") {
        return state;
      }
      return updateSession(state, action.sessionId, {
        status: "idle",
        messages: []
      });
    }

    case ActionTypes.SESSION_CREATING:
      return { ...state, isCreating: true };

    case ActionTypes.SESSION_CREATED:
      return {
        ...state,
        sessionList: [action.session, ...state.sessionList],
        activeSessionId: action.session.id,
        isCreating: false,
        openedSessions: {
          ...state.openedSessions,
          [action.session.id]: { status: "idle", messages: [] }
        }
      };

    case ActionTypes.SESSION_CREATE_FAILED:
      return { ...state, isCreating: false };

    case ActionTypes.SESSION_DELETED: {
      const nextList = state.sessionList.filter(
        (s) => s.id !== action.sessionId
      );
      const nextOpened = { ...state.openedSessions };
      delete nextOpened[action.sessionId];
      const nextActive =
        state.activeSessionId === action.sessionId
          ? (nextList[0]?.id ?? null)
          : state.activeSessionId;
      return {
        ...state,
        sessionList: nextList,
        activeSessionId: nextActive,
        openedSessions: nextOpened
      };
    }

    case ActionTypes.SESSION_TITLE_SET:
      return {
        ...state,
        sessionList: state.sessionList.map((s) =>
          s.id === action.sessionId && !s.title
            ? { ...s, title: action.title }
            : s
        )
      };

    case ActionTypes.MESSAGE_SENT:
      return appendMessage(
        updateSession(state, action.sessionId, { status: "streaming" }),
        action.sessionId,
        action.message
      );

    case ActionTypes.SSE_SUMMARY_RECEIVED:
      return appendMessage(state, action.sessionId, action.message);

    case ActionTypes.SSE_ERROR_RECEIVED:
      return appendMessage(state, action.sessionId, action.message);

    case ActionTypes.SSE_STATUS_RECEIVED:
      return updateSession(state, action.sessionId, {
        agentStatusUpdate: action.statusMessage
      });

    case ActionTypes.STREAM_COMPLETED:
      return updateSession(state, action.sessionId, {
        status: "idle",
        agentStatusUpdate: null
      });

    default:
      return state;
  }
}
